<template>
  <section class="sm-reports__top">
    <div class="sm-reports__top-flex">
      <div class="sm-reports__top-row">
        <div class="sm-reports__top-title">
          <a
            href="#" 
            @click.prevent="$router.push('reports')"
          >
            <include-svg :name="'icon-reports-sec'" />
          </a>
          <h2>Reports</h2>
        </div>
        <tabs-elem
          v-if="this.provider.client_level && this.userAccount.role"
          :tabs="tabs"
          :scroll="true"
          :defaultTabIndex="this.provider.client_level === 2 ? 1 : 0"
          @switch="handleSwitch"
        />
      </div>
      <div 
        v-if="currentTab == 'charge'"
        class="sm-reports__top-controls"
      >
        <btn-block
          v-if="provider && !provider.unlocked_access_to_all_reports "
          :type="'small'"
          :text="'View all months'"
          @click="handleEnableAllMonths"
        />
        <btn-block
          :type="'grey-cut'"
          :text="'Export CSV report'"
          :icon="'icon-export'"
          @click="$emit('requestCSV')"
        />
      </div>
       <div 
        v-if="currentTab == 'customers'"
        class="sm-reports__top-controls"
      >
        <btn-block
          :type="'grey-cut'"
          :text="'Download PDF file'"
          :icon="'icon-export'"
          @click="$emit('requestPDF')"
        />
        <btn-block
          :type="'grey-cut'"
          :text="'Export CSV report'"
          :icon="'icon-export'"
          @click="$emit('requestCSV')"
        />
      </div>
    </div>
      <popup-block
      v-if="popup.isOpen"
      :open="popup.isOpen"
      :size="'large'"
      @close="popup.isOpen = false;"
    >
      <template slot="popupContent">
        <confirm-block
          :text="`This will only be available for ${provider.days_allowed_to_show_all_months} days. You can export it to a CSV file to keep the data after selecting the desired period. Do you want to continue?`"
          :confirmType="'button'"
          :confirmText="`Confirm for ${formatPrice(provider.access_all_monthly_reports_price)}`"
          @confirm="confirmEnableAllMonths"
          @cancel="popup.isOpen = false"
        />
      </template>
    </popup-block>
    <sm-spinner :show="showSpinner" />
  </section>
</template>

<script>
import IncludeSvg from '@/components/IncludeSvg';
import Tabs from '@/components/Tabs';
import { mapActions, mapGetters } from 'vuex';
import Popup from '@/components/Popup';
import Confirm from '@/components/Confirm';
import Spinner from '@/components/Spinner'
import {FormatPrice} from '@/utils/general-data';

export default {
  name: 'reports-top',
  components: {
    'include-svg': IncludeSvg,
    'tabs-elem': Tabs,
    'sm-spinner': Spinner,
    'popup-block': Popup,
    'confirm-block': Confirm,
  },
  data() {
    return {
      allTabs: [
        {
          tab: 'global-report',
          text: 'Global Report',
          levels: [2]
        },
        {
          tab: 'charge',
          text: 'Charges'
        },
        {
          tab: 'mail',
          text: 'Mail',
        },
        {
          tab: 'customers',
          text: 'Customers',
          levels: [2,3]
        },
        {
          tab: 'sales',
          text: 'Sales',
          roles: ['manager'],
          hidden: true
        },
        {
          tab: 'yearly-revenue',
          text: 'Yearly Revenue',
          roles: ['manager'],
          hidden: true
        }
      ],
      currentTab: null,
      popup: {
        isOpen: false
      },
      showSpinner: false,
    };
  },
  computed: {
    ...mapGetters({
      provider: 'provider',
      userAccount: 'account/userAccount'
    }),
    tabs() {
      if (!this.provider.client_level || !this.userAccount.role)
        return this.allTabs;

      return this.allTabs.filter(tab => {
        if (tab.levels && !tab.levels.includes(this.provider.client_level))
          return false;

        if (tab.roles && !tab.roles.includes(this.userAccount.role))
          return false;

        return true;
      });
    }
  },
  created() {
    const defaultTab = this.provider.client_level === 2 ? 1 : 0;
    this.currentTab = this.$route.query.tab ||  this.tabs[defaultTab].tab;
  },
  methods: {
    ...mapActions({
      enableAllMonthChargesReport: 'reports/enableAllMonthsInChargesReport'
    }),
    handleSwitch(data) {
      this.currentTab = data.tab;
    },
    handleEnableAllMonths() {
      this.popup.isOpen = true;
    },
    confirmEnableAllMonths() {
      this.showSpinner = true;
      this.enableAllMonthChargesReport().then(res => {
        this.popup.isOpen = false;
        window.location.reload();
      }).catch(err => {
        this.showSpinner= false;
      })
    },
    formatPrice: FormatPrice
  }
}
</script>
